export default {"src":"/_next/static/media/sliders-horizontal.ad145cf9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};